import { jsx } from "react/jsx-runtime";
import UploadIcon from "@mui/icons-material/Upload";
import { validateTidalLicense } from "../../base/index.js";
function Upload(props) {
  return /* @__PURE__ */ jsx(
    UploadIcon,
    {
      "data-testid": "Upload",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Upload",
      "data-tidal-icon-meta": "fileActions"
    }
  );
}
Upload.tidalIconMeta = {
  categories: "fileActions",
  name: "Upload"
};
validateTidalLicense();
export {
  Upload
};
//# sourceMappingURL=Upload.js.map
